module.exports = __webpack_public_path__ + "img/user_head_man.2e4a88a1.png";